module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1532-79de1b6e949764b609c81a30296807ea.png";